import { createSlice } from '@reduxjs/toolkit';

import { baseReducerActions } from '@util/data/base-reducer-actions';

import { initialBillingState } from './subscription.initial-state';

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: initialBillingState,
  reducers: {
    ...baseReducerActions(initialBillingState),
  },
});

export const billingActions = subscriptionSlice.actions;
